export const APP_SETTING_STORE_KEY = 'APP_SETTING_STORE';
